import { VENDOR_LIST, SELECTED_VENDOR, PAYMENT_GATEWAY_LIST } from "../../actionTypes/admin";
import { UPDATE_LOGIN } from "../../actionTypes/profile";

const intialState = {
  vendorList: [],
  selectedVendor: null,
  getPaymentGateway: [],
};

export default function VendorReducers(state = intialState, action) {
  switch (action.type) {

    case VENDOR_LIST:
      return { ...state, vendorList: action.payload };

    case SELECTED_VENDOR:
      return { ...state, selectedVendor: action.payload };

    case PAYMENT_GATEWAY_LIST:
      return { ...state, getPaymentGateway: action.payload };

    case UPDATE_LOGIN:
      return (action.payload && action.payload.length)
        ? state
        : { ...state, selectedVendor: null };

    default:
      return state;
  }
}
